// ============================================================================
// GlobalBusy — indicador global de "el sistema está trabajando".
// Se suscribe al contador de peticiones en vuelo de engine.js (onBusyChange):
// cualquier operación de base (leer/guardar/subir) enciende una barra superior
// animada + un chip "Cargando…". Así el usuario sabe que su clic SÍ se registró.
// Debounce de 120ms para no parpadear en operaciones instantáneas.
// ============================================================================
import React, { useEffect, useState } from 'react';
import { onBusyChange } from '../db/engine';

export default function GlobalBusy() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let showTimer = null, hideTimer = null, shown = false;
    const unsub = onBusyChange((n) => {
      if (n > 0) {
        // Llegó actividad: cancela cualquier apagado pendiente y, si aún no se muestra,
        // enciende tras 100ms (evita destello en operaciones instantáneas).
        if (hideTimer) { clearTimeout(hideTimer); hideTimer = null; }
        if (!shown && !showTimer) showTimer = setTimeout(() => { shown = true; showTimer = null; setVisible(true); }, 100);
      } else {
        // Se acabó la actividad: NO apaga de inmediato. Espera 400ms; si llega otra
        // petición en ese lapso, se cancela el apagado → queda ESTÁTICO sin parpadear.
        if (showTimer) { clearTimeout(showTimer); showTimer = null; }
        if (shown && !hideTimer) hideTimer = setTimeout(() => { shown = false; hideTimer = null; setVisible(false); }, 400);
      }
    });
    return () => { if (showTimer) clearTimeout(showTimer); if (hideTimer) clearTimeout(hideTimer); unsub(); };
  }, []);

  return (
    <>
      <style>{`
        @keyframes ru-busy-slide {
          0%   { left: -40%; width: 40%; }
          50%  { left: 30%;  width: 45%; }
          100% { left: 100%; width: 40%; }
        }
        @keyframes ru-busy-spin { to { transform: rotate(360deg); } }
      `}</style>

      {/* Barra superior indeterminada */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, height: 3, zIndex: 100000,
        pointerEvents: 'none', overflow: 'hidden',
        opacity: visible ? 1 : 0, transition: 'opacity 180ms ease',
      }}>
        <div style={{
          position: 'absolute', top: 0, height: '100%', borderRadius: 2,
          background: 'linear-gradient(90deg, rgba(var(--sky-rgb),0) 0%, var(--sky) 50%, var(--sky-light) 100%)',
          animation: 'ru-busy-slide 1.1s ease-in-out infinite',
        }} />
      </div>

      {/* Chip "Cargando…" abajo a la derecha */}
      <div style={{
        position: 'fixed', bottom: 18, right: 18, zIndex: 100000, pointerEvents: 'none',
        display: 'flex', alignItems: 'center', gap: 8,
        padding: '7px 13px', borderRadius: 999,
        background: 'rgba(var(--navy-rgb),0.92)', border: '1px solid rgba(var(--sky-light-rgb),0.45)',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.35)',
        color: '#E6EEF7', fontSize: 12.5, fontWeight: 600, letterSpacing: 0.2,
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(8px)',
        transition: 'opacity 180ms ease, transform 180ms ease',
      }}>
        <span style={{
          width: 13, height: 13, borderRadius: '50%',
          border: '2px solid rgba(var(--silver-rgb),0.35)', borderTopColor: 'var(--sky-light)',
          display: 'inline-block', animation: 'ru-busy-spin 0.7s linear infinite',
        }} />
        Cargando…
      </div>
    </>
  );
}
